import React, { useContext } from 'react';
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
  InputAdornment,
  makeStyles
} from '@material-ui/core';
import LockIcon from '@material-ui/icons/Lock';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { FormattedMessage } from 'react-intl';
import FormContext from '../FormContext';
import { getProductArea } from 'features/DishContainer/selectors';
import { useSelector } from 'react-redux';
import { toJS } from 'utils/immutableUtils';

const useStyles = makeStyles(theme => ({
  selectRoot: {
    backgroundColor: '#fafafa !important'
  },
  selectMenu: {
    backgroundColor: '#fafafa'
  },
  formControlRoot: {
    '& .MuiFilledInput-root.Mui-disabled': {
      background: theme.palette.grey[50]
    }
  }
}));

const FilterButtonDropdown = ({
  label,
  dataField,
  items = [],
  helperText,
  disabled = false,
  onSelectChange
}) => {
  const classes = useStyles();
  const { getFieldValue, setFieldValue } = useContext(FormContext);
const productArea = useSelector(getProductArea);
  const productAreaList = toJS(productArea)
  // Safe value for Node 12/13
  const selectedValue = getFieldValue(dataField) ? getFieldValue(dataField) : '';
 if(selectedValue){ 
productAreaList.map((item)=>{
  if(item.code===selectedValue && !item.isActive){
    setFieldValue('filterCode', null);
  }
})
 }
  const handleChange = event => {
    const newValue = event.target.value;

    // Update FormContext (required for controlled Select)
    setFieldValue(dataField, newValue);

    // Notify parent
    if (onSelectChange) {
      onSelectChange(newValue);
    }
  };

  return (
    <FormControl
      fullWidth
      variant="filled"
      margin="normal"
      classes={{ root: classes.formControlRoot }}
    >
      <InputLabel>
        <FormattedMessage id={label} />
      </InputLabel>

      <Select
        value={selectedValue}
        onChange={handleChange}
        disabled={disabled}
        classes={{ root: classes.selectRoot }}
        MenuProps={{
          classes: { paper: classes.selectMenu }
        }}
        IconComponent={disabled ? () => <></> : ArrowDropDownIcon}
        endAdornment={
          disabled ? (
            <InputAdornment position="end">
              <LockIcon />
            </InputAdornment>
          ) : null
        }
      >
        <MenuItem value="">
          <em>
            <FormattedMessage id="form.selectEmptyLabel" />
          </em>
        </MenuItem>

        {items.map(function(item) {
          return (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          );
        })}
      </Select>

      {helperText && (
        <FormHelperText>
          <FormattedMessage id={helperText} />
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default FilterButtonDropdown;
